import {BillingInfo, Invoice} from '@eitje/api'
import _ from 'lodash'
import utils from '@eitje/utils'

export const useBillingInfoFilter = ({fixedFilter}) => {
	let items = _.sortBy(BillingInfo.useAll())
	const invoices = Invoice.useWhereNot({status: ['paid', 'disregard']})

	if (fixedFilter === 'withUnpaidInvoices') {
		items = items.filter(({id}) => invoices.some(({billing_info_id}) => billing_info_id === id))
	}

	const filterFn = (item, filterValues) => {
		const {id, billing_info_id} = item
		const ids = utils.alwaysArray(billing_info_id || id)

		return ids.some(id => filterValues.includes(id))
	}

	return {
		items,
		filterFn,
		labelField: 'company_name',
	}
}
